var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-12.01A127.819 127.819 0 0 0-33.145 1.744l-25.611-25.607L-104.2 21.58l25.61 25.608a127.63 127.63 0 0 0-13.753 33.146h-36.19v64.267h36.19a127.878 127.878 0 0 0 13.753 33.146l-25.61 25.607 45.444 45.444 25.611-25.609A127.715 127.715 0 0 0 0 236.943v36.191h64.267v-36.191a127.784 127.784 0 0 0 33.145-13.754l25.611 25.609 45.444-45.444-25.61-25.607a127.664 127.664 0 0 0 13.753-33.146H144.6v-35.724a143.762 143.762 0 0 1-44.834-18.602l-25.281 25.284-45.444-45.445 25.281-25.281A143.827 143.827 0 0 1 35.725 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(143.533 223.866)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c44.336 0 80.333-35.995 80.333-80.333S44.336-160.666 0-160.666s-80.333 35.995-80.333 80.333S-44.336 0 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(320.267 272.066)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a64.295 64.295 0 0 0-16.646-2.181c-35.466 0-64.266 28.797-64.266 64.267s28.8 64.267 64.266 64.267c35.468 0 64.267-28.797 64.267-64.267 0-5.753-.755-11.331-2.177-16.644L25.706 65.178l-45.444-45.445Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(192.312 274.247)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a143.8 143.8 0 0 0 44.834-18.602L70.115 6.682l45.445-45.445-25.282-25.281a143.817 143.817 0 0 0 18.597-44.833H144.6v-64.267h-35.725a143.832 143.832 0 0 0-18.597-44.832l25.282-25.281-45.445-45.444-25.281 25.282A143.797 143.797 0 0 0 0-282.02v-35.723h-64.267v35.723a143.841 143.841 0 0 0-44.834 18.601l-25.281-25.282-45.444 45.444 25.281 25.281a143.832 143.832 0 0 0-18.597 44.832h-35.725v64.267h35.725a143.827 143.827 0 0 0 18.597 44.833l-25.281 25.281 45.444 45.445 25.281-25.284A143.772 143.772 0 0 0-64.267 0v35.724H0z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(352.4 332.743)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.bc54167291035352d314e3f1607663bb.svg";
export { ForwardRef as ReactComponent };